import apiConfig from './apiConfig.js'
import axios from "axios";
import { EventBus } from "./eventBus.js";

function call(apiUrl, params, success, error) {
    if(!params.lang){
        var language = navigator.language;
        if(language=="zh-TW"||language=="zh-HK"){
            params.lang = 'zh_HK'; 
        }else if(language=="zh-CN"){
            params.lang = 'zh_CN'; 
        }else{
            params.lang = 'en_US'; 
        }
    }
    var device = (navigator.userAgent).match(/Android|iPhone|iPad|iPod/i); 

    if ( /Android/i.test(device) ) { 
        params.device = "aos";
    } else if ( /iPhone/i.test(device) ) { 
        params.device = "ios";
    } else if ( /iPad/i.test(device) ) { 
        params.device = "ios";
    }else{
        params.device = "web";
    }
    params.platformId = 1;
    params.deviceId = "";
    params.osVersion = "";
    params.mobileVersion = "";
    params.screenResolutionWidth = "";
    params.screenResolutionHight = "";
    params.appVersion = "";
    let postParams = transformParams(params)
    // let url = apiConfig.apiDomain.local + apiUrl
     let url = apiConfig.apiDomain + apiUrl
    EventBus.$emit('loading', { turn: 'on' })

    axios.post(url, postParams)
        .then(response => {
            // alert("success" + response)
            
            if(response.data.errorCode==0||response.data.errorCode ==undefined){
                success(response.data)
            }else{
                EventBus.$emit('error', { errMsg: response.data.errorMessage })
                if(typeof(error)=='function'){
                    error()
                }
            }
            EventBus.$emit('loading', { turn: 'off' })

        })
        .catch(err => {
            EventBus.$emit('error', { errMsg: err })
            if(typeof(error)=='function'){
                error()
            }else{
                defaultError(err)
            }
        })
}

function defaultError(err){
    EventBus.$emit('loading', { turn: 'off' })
}
function transformParams(params) {
    let searchParams = new FormData();
    for (var key in params) {
        searchParams.append(key, params[key])

    }
    return searchParams
}
export default {
    getEditorialDetail(data, success, error) {
        let apiUrl = apiConfig.action.getEditorialDetail
        call(apiUrl, data, success, error);
    }
}